import styled from "styled-components";
import { TextButtonProps } from "./text-button.props";
import { colors } from "../../../theme/colors";

export const TextButton = ({
  children,
  leadingIcon,
  color = "primary",
  onClick,
  disabled = false,
}: TextButtonProps) => {
  return (
    <Container onClick={onClick} $color={color} $disabled={disabled}>
      {leadingIcon ?? null}
      {children}
    </Container>
  );
};

const Container = styled.div<{
  $color: "primary" | "complement";
  $disabled: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.4rem;
  color: ${({ $color }) => colors[$color].hex};
  font-weight: 600;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  z-index: 2;
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};

  transition: opacity 0.2s;

  &:hover {
    opacity: ${({ $disabled }) => ($disabled ? 0.6 : 0.8)};
  }

  /* Prevents accidental label selection when clicking */
  -webkit-user-select: none;
  user-select: none;
`;
